import * as React from "react";
import styled from "styled-components";
import { SIDEBAR, SIDEBAR_COLLAPSED } from "../../utils/sizes";
import { WHITE } from "../../utils/colors";
import { line } from "src/theme/ui";
import Logo from "./components/Logo";
import Menu from "./components/Menu";

import { TRouteItem } from "../../types";
import { IRouteItem } from "../../routes";

interface IFinaSidebarProps {
  collapse: boolean;
  setCollapse: (collpase: boolean) => void;
  isMobile: boolean;
  routes?: IRouteItem;
}

const SideBar = styled.nav<{ $collapse?: boolean }>`
  background-color: ${WHITE};
  width: ${({ $collapse }) => ($collapse ? SIDEBAR_COLLAPSED : SIDEBAR)};
  /* Half a second to open a rail is long enough to sit and watch. Football
     moves its width in 200ms, which reads as the rail responding rather
     than as an animation. */
  transition: width 0.2s ease;
  /* An edge, not a lift. The rail is not floating above the page — it is
     beside it — and football draws that with its softest line. The shadow
     this replaces was also the last off-palette colour in the chrome. */
  border-right: 1px solid ${line.soft};
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  @media only screen and (max-width: 767px) {
    // width: ${({ $collapse }) => ($collapse ? 0 : SIDEBAR)};
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const BackgroundCollpase = styled.div`
  position: fixed;
  background-color: black;
  width: 100vw;
  height: 100vh;
  opacity: 0.4;
  z-index: 2;
  animation: visibility 2s linear 2s, opacity 2ss;
`;

const FinaSidebar: React.FunctionComponent<IFinaSidebarProps> = ({
  collapse,
  setCollapse,
  isMobile,
  routes,
}) => {
  return (
    <>
      {collapse === false && isMobile && (
        <BackgroundCollpase
          onClick={() => {
            if (collapse === false) setCollapse(true);
          }}
        />
      )}
      <SideBar $collapse={collapse}>
        <Content>
          <Logo isCollapsed={collapse} />
          {/* The collapse control now lives at the foot of the rail, beside
              the name, rather than as an invisible strip down this edge —
              so the menu renders it, where that row is. */}
          <Menu
            routes={routes}
            collapse={collapse}
            setCollapse={!isMobile ? setCollapse : undefined}
          />
        </Content>
      </SideBar>
    </>
  );
};

export default FinaSidebar;
